export const customerAddIcon = require("../assets/customer_add_icon.png");
export const customerViewIcon = require("../assets/customer_view_icon.png");
export const DeleteProductIcon = require("../assets/button_delete_item.png");
export const IconCalender = require("../assets/calender.png");
export const cartEmptyImage = require("../assets/image_empty_cart.svg");
export const checked = require("../assets/image_shopping_cart.svg");
export const contractActive = require("../assets/contract_active.svg");